import ApiBaseService from './ApiBaseService';

class VenueService {

    static uploadFile([formData]) {
        const headers = { 'Content-Type': 'multipart/form-data' };
        return ApiBaseService.request(`api/web/file/upload`, 'POST', formData, headers);
    }

    // VENUE
    static getVenueList([data]) {
        return ApiBaseService.request('/api/web/venue/list', 'POST', data);
    }
    static getVenueDropdownList([data = {}]) {
        return ApiBaseService.request('/api/web/venue/dropdown', 'POST', data);
    }
    static createVenue([data]) {
        return ApiBaseService.request('/api/web/venue/create', 'POST', data);
    }
    static updateVenueByUuid([data, venueUuid]) {
        return ApiBaseService.request(`/api/web/venue/update/${venueUuid}`, 'PUT', data);
    }
    static getVenueByUuid([venueUuid]) {
        return ApiBaseService.request(`/api/web/venue/details/${venueUuid}`, 'GET');
    }
    static removeVenueByUuid([venueUuid]) {
        return ApiBaseService.request(`/api/web/venue/remove/${venueUuid}`, 'PUT', {});
    }
    static getVenueStatistics([data]) {
        return ApiBaseService.request(`/api/web/venue/statistics`, 'POST', data);
    }
    static changeVenueStatusByUuid([venueUuid]) {
        return ApiBaseService.request(`/api/web/venue/status/${venueUuid}`, 'PUT', {});
    }
    static getVenuetatistics([uuid_venue]) {
        return ApiBaseService.request(`/api/web/venue/dashboard/statistics/${uuid_venue}`, 'GET');
    }

    // TURF
    static getTurfList([data]) {
        return ApiBaseService.request('/api/web/turf/list', 'POST', data);
    }
    static getTurfDropdownList([data]) {
        return ApiBaseService.request('/api/web/turf/dropdown', 'POST', data);
    }
    static createTurf([data]) {
        return ApiBaseService.request('/api/web/turf/create', 'POST', data);
    }
    static updateTurfByUuid([data, turfUuid]) {
        return ApiBaseService.request(`/api/web/turf/update/${turfUuid}`, 'PUT', data);
    }
    static getTurfByUuid([turfUuid]) {
        return ApiBaseService.request(`/api/web/turf/details/${turfUuid}`, 'GET');
    }
    static removeTurfByUuid([turfUuid]) {
        return ApiBaseService.request(`/api/web/turf/remove/${turfUuid}`, 'PUT', {});
    }
    static getTurfBooking([data]) {
        return ApiBaseService.request(`/api/web/turf/bookings`, 'POST', data);
    }
    static changeTurfStatusByUuid([turfUuid]) {
        return ApiBaseService.request(`/api/web/turf/status/${turfUuid}`, 'PUT', {});
    }

    // PRICE
    static getPriceList([data]) {
        return ApiBaseService.request('/api/web/price_config/list', 'POST', data);
    }
    static createPrice([data]) {
        return ApiBaseService.request('/api/web/price_config/create', 'POST', data);
    }
    static updatePriceByUuid([data, priceUuid]) {
        return ApiBaseService.request(`/api/web/price_config/update/${priceUuid}`, 'PUT', data);
    }
    static getPriceByUuid([priceUuid]) {
        return ApiBaseService.request(`/api/web/price_config/details/${priceUuid}`, 'GET');
    }
    static removePriceByUuid([priceUuid]) {
        return ApiBaseService.request(`/api/web/price_config/remove/${priceUuid}`, 'PUT', {});
    }
    static changePriceStatusByUuid([priceUuid]) {
        return ApiBaseService.request(`/api/web/price_config/status/${priceUuid}`, 'PUT', {});
    }

    // Bank Account
    static getBankAccountList([data]) {
        return ApiBaseService.request('/api/web/venue_account/list', 'POST', data);
    }
    static createBankAccount([data]) {
        return ApiBaseService.request('/api/web/venue_account/create', 'POST', data);
    }
    static updateBankAccountByUuid([data, accountUuid]) {
        return ApiBaseService.request(`/api/web/venue_account/update/${accountUuid}`, 'PUT', data);
    }

    // SETTINGS
    static getVenueSettings([data]) {
        return ApiBaseService.request('/api/web/venue_config/list', 'POST', data);
    }
    static createVenueSettings([data]) {
        return ApiBaseService.request('/api/web/venue_config/create', 'POST', data);
    }
    static updateVenueSettings([data, configUuid]) {
        return ApiBaseService.request(`/api/web/venue_config/update/${configUuid}`, 'PUT', data);
    }

    // BOARD
    static getBoardList([data]) {
        return ApiBaseService.request('/api/scoreboard/list', 'POST', data);
    }
    static createBoard([data]) {
        return ApiBaseService.request('/api/scoreboard/create', 'POST', data);
    }
    static updateBoardByUuid([data, boardUuid]) {
        return ApiBaseService.request(`/api/scoreboard/update/${boardUuid}`, 'PUT', data);
    }
    static getBoardByUuid([boardUuid]) {
        return ApiBaseService.request(`/api/scoreboard/details/${boardUuid}`, 'GET');
    }
    static removeBoardByUuid([boardUuid]) {
        return ApiBaseService.request(`/api/scoreboard/remove/${boardUuid}`, 'PUT', {});
    }
    static getBoardBookings([data]) {
        return ApiBaseService.request(`/api/scoreboard/bookings`, 'POST', data);
    }
    static changeBoardStatusByUuid([boardUuid]) {
        return ApiBaseService.request(`/api/scoreboard/status/${boardUuid}`, 'PUT', {});
    }
    static getBoardLog([data]) {
        return ApiBaseService.request(`/api/scoreboard/log`, 'POST', data);
    }
    static revokeBoardStatusByUuid([boardUuid, data]) {
        return ApiBaseService.request(`/api/scoreboard/revoke/${boardUuid}`, 'PUT', data);
    }
    static getBoardUsageLog([data]) {
        return ApiBaseService.request(`/api/web/scoreboard/usage_log`, 'POST', data);
    }
    static getBoardUsageLogByUuid([bookingUuid]) {
        return ApiBaseService.request(`/api/web/scoreboard/usage_log/${bookingUuid}`, 'GET');
    }
    static getBoardStatistics([uuid_board]) {
        return ApiBaseService.request(`/api/web/scoreboard/dashboard/statistics/${uuid_board}`, 'GET');
    }
    static getBoardStatisticsByDate([uuid_board, data]) {
        return ApiBaseService.request(`/api/web/scoreboard/dashboard/statistics/${uuid_board}`, 'POST', data);
    }

}

export default VenueService;